import React from "react";
import { useTranslate } from "ra-core";
import clsx from "clsx";
import { makeStyles } from "@material-ui/core/styles";
import { Grid } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  spanCardMediaLeft: {
    position: "relative",
    float: "left",
    fontSize: "23px",
    padding: "56px 0px 0px 47px",
  },
  spanCardMediaRight: {
    position: "relative",
    float: "left",
    fontSize: "23px",
    padding: "56px 0px 0px 4px",
    textTransform: "lowercase",
  },
  logoContainer: {
    height: "150px",
  },
}));

export function TextoEntrar() {
  const classes = useStyles();
  const translate = useTranslate();

  return (
    <Grid container className={clsx(classes.logoContainer)}>
      <div className={clsx(classes.spanCardMediaLeft, "spanCardMediaLeft")}>
        <span >
          {translate("ra.auth.entrar_en")}
        </span>
      </div>
      <div className={clsx(classes.spanCardMediaRight, "spanCardMediaRight")}>
        <span >{document.title}</span>
        <spam> {translate("ra.auth.entrar_en_post")}</spam>
      </div>

    </Grid>
  );
}
